import global from '@helpers/global';
import styled, { css } from 'styled-components';

const baseContainer = css`
  padding: 0px ${global.contentPadding}px;
  margin: 0 auto;
  width: 100%;
`;

const Thin = styled.div`
  ${baseContainer};
  max-width: 860px;
`;

const DefaultStyles = css`
  ${baseContainer};
  max-width: 1300px;
`;

const Default = styled.div`
  ${DefaultStyles}
`;

const Wide = styled.div`
  ${baseContainer};
  max-width: 1500px;
`;

const ExtraWide = styled.div`
  ${baseContainer};
  max-width: 1920px;
`;

const RightOverflow = styled.div`
  padding-left: ${global.contentPadding}px;
  margin-left: auto;
  max-width: calc(((100vw - 1500px) / 2) + 1500px);
`;

const Content = styled.div`
  ${baseContainer};
  max-width: 780px;
`;

const Containers = {
  Default,
  Thin,
  Wide,
  ExtraWide,
  RightOverflow,
  Content,
  DefaultStyles,
};

export default Containers;
